/* ---------------------------------------------------------------------------
   THREADS ON DESIGN - THE CART REDRAWS WHAT THEY DESIGNED.

   Mack, 12 Sep 2026: "can you do a previewer of the selected capes and aprons
   on the checkout window like the bundles does".

   Five people reached the checkout on 11 Sep and none of them finished. The
   cart was showing a stock photograph of a black cape - the same picture for
   every order in the shop - beside a list of words. Nothing on that screen was
   theirs. This draws their actual lettering, in their alphabet, in their cone,
   at the height it will be stitched, on the garment it is going onto, and puts
   it where the stock photograph was.

   It is not a new drawing engine. kernOf, glyphBox, glyphWidth, drawGlyphLine
   and canSet below are lifted out of assets/tod-solo.js unchanged, so what the
   cart shows and what the designer showed cannot drift apart - and neither can
   disagree with make_order.py, which walks the same pen.

   WHERE THE DESIGN COMES FROM. Everything needed is already on the line item,
   and /cart.js hands back the private underscore properties as well as the
   visible ones:
     the single cape   Line 1 / Line 2 / Line 3, Font, Thread, _Letter height
     the set designer  _TOD Spec, the JSON the Order Desk reads
   If neither is there, or the alphabet has no drawing for a character, the
   line is left exactly as the theme rendered it. A cart that quietly stays
   ordinary is a great deal better than one with a hole in it.
--------------------------------------------------------------------------- */
(function () {
  var C = window.TOD_CART_PREVIEW;
  if (!C || !C.capeImg) return;

  var NS = 'http://www.w3.org/2000/svg';
  function el(t, a) {
    var e = document.createElementNS(NS, t);
    for (var k in a) { e.setAttribute(k, a[k]); }
    return e;
  }

  /* The same stage the designer draws on: one svg pixel is one millimetre of
     garment, the chest line is y 205, and the lettering is centred on x 260. */
  var GEO = {
    cape:  { img: C.capeImg,  x: -156, y: -10, w: 832, h: 1041, chest: 205 },
    apron: { img: C.apronImg, x: 53,   y: -84, w: 414, h: 943,  chest: 205 }
  };
  var LINE_GAP_MM = 4;

  /* The fifteen cones, in the workshop's own order and under the workshop's
     own names - this list is make_order.py's THREADS, which is also what
     fonts.json now carries. Four of them were renamed after 16 Aug: Coral
     Pink became Petal Pink, Teal Green became Aqua, Magenta became Hot Pink,
     Royal Blue became Azure. The SPOOL NUMBER is the thing that never moved,
     so that is what is matched on first; the old names are listed after it so
     an order taken before the rename still draws in the right colour. */
  var THREADS = [
    {name:'White',spool:'401',hex:'#E5E7EB'},       {name:'Cream',spool:'674',hex:'#EBDBC4'},
    {name:'Petal Pink',spool:'4',hex:'#F7C8DB'},    {name:'Champagne',spool:'164',hex:'#E0CEC2'},
    {name:'Lavender',spool:'270',hex:'#DAC1E9'},    {name:'Aqua',spool:'323',hex:'#93D4E0'},
    {name:'Silver',spool:'1184',hex:'#C6C7CD'},     {name:'Blush Pink',spool:'48',hex:'#FAADB6'},
    {name:'Gold',spool:'1050',hex:'#DAB654'},       {name:'Sky Blue',spool:'1086',hex:'#47B8DF'},
    {name:'Hot Pink',spool:'1002',hex:'#F189B9'},   {name:'Azure',spool:'334',hex:'#42A7F0'},
    {name:'Bronze',spool:'739',hex:'#BB9181'},      {name:'Medium Purple',spool:'1129',hex:'#A272D9'},
    {name:'Red',spool:'519',hex:'#EF3139'}
  ];
  var RENAMED = {'coral pink':'Petal Pink', 'teal green':'Aqua',
                 'magenta':'Hot Pink', 'royal blue':'Azure'};
  /* Returns a hex, or NULL when the cone cannot be identified. Null means the
     line keeps its photograph. Guessing a colour here - the first version
     fell back to gold - is the one failure this file must not have: a drawing
     in the wrong thread is worse than no drawing, because it looks right. */
  function threadHex(s) {
    if (!s) return null;
    var txt = String(s).replace(/\s+/g, ' ').trim(), i;
    var sp = /(\d{1,4})\s*$/.exec(txt);
    if (sp) { for (i = 0; i < THREADS.length; i++) if (THREADS[i].spool === sp[1]) return THREADS[i].hex; }
    var low = txt.toLowerCase().replace(/\s*[·•]\s*/g, ' ').replace(/madeira/g, '')
                 .replace(/\(?\s*spool\s*\d+\s*\)?/g, '').replace(/\d+/g, '');
    low = low.replace(/\s+/g, ' ').trim();
    for (i = 0; i < THREADS.length; i++) if (low === THREADS[i].name.toLowerCase()) return THREADS[i].hex;
    if (RENAMED[low]) { for (i = 0; i < THREADS.length; i++) if (THREADS[i].name === RENAMED[low]) return THREADS[i].hex; }
    for (i = 0; i < THREADS.length; i++) if (low.indexOf(THREADS[i].name.toLowerCase()) === 0) return THREADS[i].hex;
    return null;
  }

  /* ---- THE ALPHABETS, FETCHED THE WAY THE DESIGNER FETCHES THEM ---------- */
  var GLYPHS = {}, GPEND = {}, GFAIL = {};
  function glyphs(id) { return GLYPHS[id] || null; }
  /* 26 OCT 2026. One file per size, the same as the designer: a line is
     redrawn from the file the Order Desk builds its height from, so the cart
     shows the letters the machine will sew rather than the 25 mm ones
     enlarged. A key is "anderson" or "anderson@51". */
  function glyphUrl(key) {
    var at = key.indexOf('@');
    if (at < 0) return (window.TOD_GLYPHS || {})[key] || null;
    var m = (window.TOD_GLYPH_SIZES || {})[key.slice(0, at)];
    return (m && m[key.slice(at + 1)]) || null;
  }
  function srcFor(id, mm) {
    var m = (window.TOD_GLYPH_SIZES || {})[id]; if (!m) return null;
    var ks = Object.keys(m).map(Number).filter(function (v) { return v > 0; }).sort(function (a, b) { return a - b; });
    if (!ks.length) return null;
    for (var i = 0; i < ks.length; i++) if (ks[i] >= mm) return ks[i];
    return ks[ks.length - 1];
  }
  function glyphsAt(id, mm) {
    var src = srcFor(id, mm), base = GLYPHS[id] || null;
    if (src === null || (base && base.srcMm === src)) return base;
    var key = id + '@' + src;
    if (GLYPHS[key]) return GLYPHS[key];
    if (GFAIL[key] || !glyphUrl(key)) return base;
    return null;
  }
  function needKey(id, mm) {
    var src = srcFor(id, mm), base = GLYPHS[id] || null;
    if (!base) return id;
    if (src === null || base.srcMm === src) return null;
    var key = id + '@' + src;
    return (GLYPHS[key] || GFAIL[key] || !glyphUrl(key)) ? null : key;
  }
  function loadGlyphs(id, cb) {
    if (GLYPHS[id]) { if (cb) cb(GLYPHS[id]); return; }
    if (GFAIL[id]) return;
    var url = glyphUrl(id);
    if (!url) { GFAIL[id] = 1; return; }
    if (GPEND[id]) { if (cb) GPEND[id].push(cb); return; }
    GPEND[id] = cb ? [cb] : [];
    fetch(url).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var q = GPEND[id] || []; GPEND[id] = null;
        if (!j || !j.g || !j.ord) { GFAIL[id] = 1; return; }
        GLYPHS[id] = j;
        for (var i = 0; i < q.length; i++) { try { q[i](j); } catch (e) {} }
      })
      .catch(function () { GPEND[id] = null; GFAIL[id] = 1; });
  }

  function kernOf(d,a,b){
    var o=d.ord, n=o.length, i=o.indexOf(a), j=o.indexOf(b);
    if (i<0||j<0||!d.kk) return 0;
    var off=(i*n+j)*2, c0=d.kk.charCodeAt(off), c1=d.kk.charCodeAt(off+1);
    if (isNaN(c0)||isNaN(c1)) return 0;
    var v=d.kv[(c0-32)*90+(c1-32)];
    return typeof v==='number' ? v : 0;
  }
  /* THE PEN WALK, character for character the way the Order Desk walks it.
     6 Sep: it used to skip anything it had no drawing for - and no alphabet
     file carries a drawing for a SPACE, so every space was worth nothing.
     "Shine hair studio" measured 8% narrow, the page offered 27 mm where only
     24 fits the cape, and the preview drew the words run together. The space
     is a real advance: it is the spaceT the file has carried all along. It
     also breaks the kerning run rather than being kerned across, and trackT
     opens whatever pairs are left, both exactly as the desk does it.
     The width returned is the ink box, so a leading or trailing space is not
     counted - the desk does not count one either. */
  function glyphBox(d,text){
    var pen=0, prev=null, n=0, x0=0, x1=0;
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      if (ch===' '){ if(n && x1>pen) pen=x1; pen+=(d.spaceT||0); prev=null; continue; }
      var e=d.g[ch];
      if (!e){ prev=null; continue; }
      if (prev!==null) pen+=kernOf(d,prev,ch)+(d.trackT||0);
      if (!n || pen<x0) x0=pen;
      if (!n || pen+e[1]>x1) x1=pen+e[1];
      pen+=e[1]; prev=ch; n++;
    }
    return n ? {x0:x0, w:x1-x0} : null;
  }
  /* Width of a line in glyph units, kerning included. */
  function glyphWidth(d,text){ var b=glyphBox(d,text); return b?b.w:0; }
  /* Draw one line on a baseline, centred on cx. mm is the capital height the
     customer chose; the file is cut at d.srcMm, so one glyph unit is
     (mm/srcMm)/10 of a stage millimetre. */
  function drawGlyphLine(parent,d,text,cx,baseY,mm,fill){
    var b=glyphBox(d,text); if(!b) return 0;
    var s=(mm/(d.srcMm||25))/10, x=cx-(b.w*s)/2-b.x0*s, pen=0, prev=null, drew=0, rt=null;
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      if (ch===' '){ if(rt!==null && rt>pen) pen=rt; pen+=(d.spaceT||0); prev=null; continue; }
      var e=d.g[ch];
      if (!e){ prev=null; continue; }
      if (prev!==null) pen+=kernOf(d,prev,ch)+(d.trackT||0);
      var gx=x+pen*s, gy=baseY-e[2]*s;
      var grp=el('g',{transform:'translate('+gx.toFixed(2)+','+gy.toFixed(2)+') scale('+s.toFixed(5)+')'});
      grp.appendChild(el('path',{d:e[0],fill:'none',stroke:fill,'stroke-width':4.2,
        'stroke-linecap':'round','stroke-linejoin':'round'}));
      parent.appendChild(grp);
      pen+=e[1]; prev=ch; drew++;
      if (rt===null || pen>rt) rt=pen;
    }
    return drew;
  }
  /* Every character in the line has a drawing, so the alphabet can set it.
     A SPACE has no drawing and never will, and this used to fail on it - so
     any name with a space fell through to the stand-in web font, which since
     the 6 Sep change leaves Add to cart stuck on "One moment...". A space is
     settable: the machine simply moves the pen. */
  function canSet(d,text){
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      if (ch!==' ' && !d.g[ch]) return false;
    }
    return true;
  }

  /* ---- READING ONE CART LINE -------------------------------------------- */
  /* An alphabet is named on the order the way the customer saw it - "Great
     Vibes" - and its drawing is filed under its id. The id is the name in
     lower case with the spaces turned into hyphens, which is how every one of
     the thirty was named; anything that does not resolve to a file we have is
     simply not drawn. */
  function fontId(name) {
    if (!name) return null;
    var id = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    var map = window.TOD_GLYPHS || {};
    return map[id] ? id : null;
  }
  /* "Tallest (38 mm) - drawn at 37 mm to fit". The DRAWN figure is the one to
     believe: it is what the page put on the cape after the width of the
     garment had its say, and it is what the machine will produce. */
  function heightMm(s) {
    if (!s) return null;
    var d = /drawn at\s*([\d.]+)\s*mm/i.exec(s);
    if (d) return parseFloat(d[1]);
    var a = /\(\s*([\d.]+)\s*mm\s*\)/.exec(s);
    if (!a) return null;
    var v = parseFloat(a[1]);
    return v > 0 ? v : null;
  }
  function propMap(item) {
    var out = {}, p = item.properties || {};
    for (var k in p) { if (p[k] != null && p[k] !== '') out[String(k).replace(/^_+/, '')] = String(p[k]); }
    return out;
  }
  /* What to draw for one line item: a garment and its lines, or nothing. */
  function designs(item) {
    var p = propMap(item), out = [];

    /* The set designer writes the whole order as JSON. It carries the height
       in millimetres and the cone's own hex, so nothing has to be guessed. */
    var raw = (item.properties || {})['_TOD Spec'] || (item.properties || {})['TOD Spec'];
    if (raw) {
      try {
        var spec = JSON.parse(raw);
        ['cape', 'apron'].forEach(function (g) {
          var sp = spec[g];
          if (!sp || !sp.lines || !sp.lines.length) return;
          var lines = sp.lines.map(function (l) {
            return { text: (l.text || '').trim(), id: fontId(l.fontId) || fontId(l.font),
                     mm: Number(l.heightMm) || null,
                     hex: l.hex || threadHex((l.color || '') + ' ' + (l.spool || '')) };
          }).filter(function (l) { return l.text; });
          /* All of it or none of it. Dropping one line and drawing the rest
             would show a customer a confident picture of half their name. */
          var whole = lines.length && lines.every(function (l) { return l.id && l.mm && l.hex; });
          if (whole) out.push({ view: g, lines: lines });
        });
        return out;
      } catch (e) { out = []; }
      /* A spec that was there and could not be read does not fall through to
         the single-cape reader: a bundle's product title contains the word
         apron, so the cape's lettering would be drawn on an apron. */
      return out;
    }

    /* THE SINGLE CAPE AND ITS MATCHING APRON.

       19 SEP 2026. THREE LINES, AND EACH ONE CAN CARRY ITS OWN ALPHABET AND
       ITS OWN CONE. The designer writes one of two shapes and this reads
       both:

         every line the same    Font, Thread            - what it always wrote
         the lines differ       Font line N, Thread line N, and _Mixed

       Before today this asked for Font and Thread and nothing else. A design
       with two alphabets on it has NO plain Font property at all, so id came
       back null and the whole row fell through to the stock photograph - the
       orders most worth showing somebody were the ones that showed nothing.
       Line three was not read either, so a third line was simply missing off
       the drawing.

       Per line first, then the design-wide one. The height is already written
       per line - _Letter height for line one, _Letter height line N after it -
       and that has not changed.

       ALL OF IT OR NONE OF IT, the same rule the set designer's branch keeps
       above: if any live line cannot be resolved to an alphabet, a cone and a
       millimetre, this row keeps its photograph rather than showing a
       customer a confident picture that is missing a line. */
    var texts = [p['Line 1'], p['Line 2'], p['Line 3']];
    if (!texts[0]) return out;
    var view = /apron/i.test(item.product_title || item.title || '') ? 'apron' : 'cape';
    var lines = [], whole = true;
    for (var i = 0; i < texts.length; i++) {
      var t = texts[i] ? String(texts[i]).trim() : '';
      if (!t) continue;
      var id  = fontId(p['Font line ' + (i + 1)] || p['Font']);
      var hex = threadHex(p['Thread line ' + (i + 1)] || p['Thread']);
      var mm  = heightMm(i === 0 ? p['Letter height'] : p['Letter height line ' + (i + 1)]);
      /* An older order wrote one height for the whole design. */
      if (!mm) mm = heightMm(p['Letter height']);
      if (!id || !hex || !mm) { whole = false; break; }
      lines.push({ text: t, id: id, mm: mm, hex: hex });
    }
    if (!whole || !lines.length) return out;
    out.push({ view: view, lines: lines });
    return out;
  }

  /* ---- THE PICTURE ------------------------------------------------------- */
  /* Returns an svg, or null when the alphabet cannot set one of the lines -
     in which case the line keeps the photograph it already had rather than
     showing lettering with a character missing out of the middle of it. */
  function draw(design) {
    var G = GEO[design.view]; if (!G || !G.img) return null;
    var ready = true;
    design.lines.forEach(function (l) {
      var k = needKey(l.id, l.mm);
      if (k) { ready = false; loadGlyphs(k, schedule); return; }
      var d = glyphsAt(l.id, l.mm);
      if (!d || !canSet(d, l.text)) ready = false;
    });
    if (!ready) return null;

    var svg = el('svg', { viewBox: '0 0 520 380', role: 'img' });
    svg.setAttribute('class', 'tod-cartprev__svg');
    /* The photograph it replaces carried the product's alt text, so without
       this the link around it has no accessible name at all. */
    var ttl = el('title', {});
    ttl.textContent = 'Your ' + design.view + ', embroidered ' +
      design.lines.map(function (l) { return l.text; }).join(' / ');
    svg.appendChild(ttl);
    svg.setAttribute('aria-label', ttl.textContent);
    var im = el('image', { x: G.x, y: G.y, width: G.w, height: G.h, preserveAspectRatio: 'none' });
    im.setAttribute('href', G.img);
    svg.appendChild(im);

    var g = el('g', {});
    var total = 0;
    design.lines.forEach(function (l) { total += l.mm; });
    total += (design.lines.length - 1) * LINE_GAP_MM;
    var y = G.chest - total / 2, drew = 0;
    design.lines.forEach(function (l) {
      drew += drawGlyphLine(g, glyphsAt(l.id, l.mm), l.text, 260, y + l.mm, l.mm, l.hex);
      y += l.mm + LINE_GAP_MM;
    });
    if (!drew) return null;
    svg.appendChild(g);
    return svg;
  }

  /* ---- THE BIG ONE ------------------------------------------------------- */
  /* The thumbnail in a cart row is about 120px wide on a desktop and smaller
     on a phone, which is enough to recognise your own cape and not enough to
     read the spelling on it. Tapping it opens the same drawing full size,
     because checking the spelling is the one thing somebody looking at this
     screen might actually still want to do. */
  var box = null;
  function lightbox(svg, label) {
    if (!box) {
      box = document.createElement('div');
      box.className = 'tod-cartprev__box';
      box.setAttribute('hidden', 'hidden');
      box.innerHTML = '<button type="button" class="tod-cartprev__x" aria-label="Close">&#10005;</button>' +
                      '<figure><div class="tod-cartprev__big"></div><figcaption></figcaption></figure>';
      box.addEventListener('click', function (e) {
        if (e.target === box || (e.target.closest && e.target.closest('.tod-cartprev__x'))) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.body.appendChild(box);
    }
    var host = box.querySelector('.tod-cartprev__big');
    host.innerHTML = '';
    host.appendChild(svg);
    box.querySelector('figcaption').textContent = label || '';
    box.removeAttribute('hidden');
    /* Whatever the page had is put back on close, not the empty string: the
       cart drawer locks scrolling the same way, and clearing it from under an
       open drawer would let the page behind it scroll. */
    wasOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var x = box.querySelector('.tod-cartprev__x');
    if (x) x.focus();
  }
  var wasOverflow = '';
  function close() {
    if (!box || box.hasAttribute('hidden')) return;
    box.setAttribute('hidden', 'hidden');
    document.documentElement.style.overflow = wasOverflow;
    if (lastZoom && lastZoom.focus) { try { lastZoom.focus(); } catch (e) {} }
  }
  var lastZoom = null;

  /* ---- PUTTING IT IN THE ROW --------------------------------------------- */
  /* Each row is redrawn once per design. The key is the line item's own key
     plus what is being drawn, so changing a quantity - which re-renders the
     table - does not redraw anything, and a genuinely different design does. */
  function fill(row, item) {
    if (!row) return;
    var ds = designs(item);
    if (!ds.length) return;
    var sig = JSON.stringify(ds);
    /* Kept on the row ELEMENT, not in a table keyed by the line item. A cart
       page can hold the same line twice - the drawer's copy and the table's -
       and a shared key let one of them mark the design done on behalf of the
       other, which left the visible one with its stock photograph. */
    if (row.__todSig === sig && row.querySelector('.tod-cartprev__svg')) return;

    var svg = draw(ds[0]);
    if (!svg) return;
    var cell = row.querySelector('.cart-items__media-container') || row.querySelector('.cart-items__media');
    if (!cell) return;
    var img = cell.querySelector('img');
    /* An inline style, not the hidden attribute: [hidden] is a user-agent rule
       and any theme rule that sets display on the cart thumbnail beats it. */
    if (img) { img.style.display = 'none'; img.setAttribute('aria-hidden', 'true'); }
    var old = cell.querySelector('.tod-cartprev__svg');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    cell.appendChild(svg);
    cell.classList.add('tod-cartprev');
    cell.__todDs = ds;
    cell.__todLabel = (item.product_title || item.title || '') + ' - ' +
                      ds[0].lines.map(function (l) { return l.text; }).join(' / ');
    if (cell.tagName === 'A' && !cell.__todZoom) {
      cell.__todZoom = 1;
      cell.addEventListener('click', function (e) {
        var d = cell.__todDs;
        if (!d) return;
        var big = draw(d[0]);
        if (!big) return;          /* let the link do its ordinary job */
        e.preventDefault();
        lastZoom = cell;
        lightbox(big, cell.__todLabel);
      });
    }
    row.__todSig = sig;
  }

  /* ---- WHEN TO LOOK ------------------------------------------------------ */
  /* 12 SEP 2026, THE FIX. Mack: "the custom mockup of the order dissapeared
     when readding stuff to the cart."

     The theme does not update a cart row, it renders a fresh one and swaps the
     old one out - that is how adding, removing and every change of quantity
     work here. The first version of this read the rows off the page BEFORE
     asking /cart.js what was in them, and a round trip is long enough for the
     swap to happen in the middle of it. The drawings were still being made;
     they were being appended to rows that had already been thrown away, so
     nothing appeared and nothing said why.

     So the rows are now looked up AFTER the answer comes back, never before.
     Two more things follow from the same cause: a request that is already out
     when the table changes remembers to go round again instead of dropping the
     change, and the watcher sits on something that outlives the table rather
     than on the table itself. */
  var busy = false, again = false, timer = null, writing = false;
  /* Every row that carries the key, not the last one seen. The cart drawer
     and the cart page render the same line item from the same component, so
     on /cart both can be in the document at once. */
  function rowMap() {
    var m = {}, els = document.querySelectorAll('.cart-items__table-row[data-key]');
    for (var i = 0; i < els.length; i++) {
      var k = els[i].getAttribute('data-key');
      (m[k] || (m[k] = [])).push(els[i]);
    }
    return m;
  }
  function run() {
    if (busy) { again = true; return; }
    if (!document.querySelector('.cart-items__table-row[data-key]')) return;
    /* A glyph file that failed once is allowed one more go on the next pass.
       Marked permanently, a single dropped request on a phone meant that
       customer never saw their preview again, on any row, for the whole
       visit. */
    GFAIL = {};
    busy = true; again = false;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        busy = false;
        if (c && c.items) {
          var rows = rowMap();
          /* Our own appends are mutations too, and the watcher below cannot
             tell them from the theme's. Without this the page would ask
             /cart.js again for every picture it drew. */
          writing = true;
          c.items.forEach(function (it) {
            var list = rows[it.key] || [];
            for (var i = 0; i < list.length; i++) { try { fill(list[i], it); } catch (e) {} }
          });
          /* The retry waits for the flag to clear, or schedule() would refuse
             it and a change that arrived mid-request would be lost. */
          setTimeout(function () { writing = false; if (again) schedule(); }, 0);
        } else if (again) { schedule(); }
      })
      .catch(function () { busy = false; if (again) { again = false; schedule(); } });
  }
  function schedule() {
    if (writing) return;
    clearTimeout(timer);
    timer = setTimeout(run, 140);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  setTimeout(schedule, 900);
  setTimeout(schedule, 2400);
  /* Watched on the body, because the cart table, its wrapper and the drawer
     are each replaced whole at some point and a watcher attached to any of
     them stops hearing anything the moment it is. It is cheap: every wake
     debounces to one timer, and run() leaves immediately on a page with no
     cart rows on it - which is most of them. */
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:refresh', schedule);
  window.addEventListener('pageshow', schedule);
})();
